var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"el-fade-in-linear"}},[(_vm.visible)?_c('div',{staticClass:"popup-toast"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }